import "dayjs/locale/en";
import "dayjs/locale/nl";
import "dayjs/locale/fr";

import dayjs from "dayjs";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider as Provider } from "@mui/x-date-pickers/LocalizationProvider";

import { useTranslate } from "./use-locales";
import type { ReactNode } from "react";

// ----------------------------------------------------------------------

type Props = {
	children: ReactNode;
};

export function LocalizationProvider({ children }: Props) {
	const { currentLang } = useTranslate();

	dayjs.locale(currentLang.adapterLocale);

	return (
		<Provider
			dateAdapter={AdapterDayjs}
			adapterLocale={currentLang.adapterLocale}
		>
			{children}
		</Provider>
	);
}
